import { createListFilters, IOption } from '../../../../../components'

export type ClientesFilters = {
  /** Instituição dona das entidades (obrigatória para listar). */
  empresa?: IOption<number>
  status?: IOption<boolean>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<ClientesFilters>({
  empresa: undefined,
  status: undefined,
})
